// Admin content areas a "marketer" account can be granted.
// Keys must match backend/src/app/core/content-sections.ts.
export const CONTENT_SECTIONS = [
  { key: "releases", label: "Releases", path: "/releases", icon: "fa-rocket" },
  {
    key: "product-sheets",
    label: "Product Sheets",
    path: "/product-sheet",
    icon: "fa-file-lines",
  },
  { key: "documents", label: "Documents", path: "/documents", icon: "fa-folder-open" },
  { key: "brand-guide", label: "Brand Guide", path: "/brand-guide", icon: "fa-palette" },
  { key: "graphics", label: "Graphics", path: "/graphics", icon: "fa-images" },
  { key: "events", label: "Events", path: "/events", icon: "fa-calendar-plus" },
  { key: "academy", label: "Luxia Academy", path: "/academy", icon: "fa-graduation-cap" },
];

export const sectionLabel = (key: string) =>
  CONTENT_SECTIONS.find((s) => s.key === key)?.label ?? key;

/**
 * Whether the signed-in user may open a section. Full admins see everything
 * (including Users and Deals, which carry no section key); marketers only see
 * the sections granted on their account.
 */
export const canAccessSection = (
  user: { accountType?: string; contentAccess?: string[] } | null,
  sectionKey?: string
): boolean => {
  if (!user) return false;
  if (user.accountType !== "marketer") return true;
  return !!sectionKey && (user.contentAccess ?? []).includes(sectionKey);
};

/** Where a user should land: Users for admins, their first section for marketers. */
export const landingPathFor = (
  user: { accountType?: string; contentAccess?: string[] } | null
): string => {
  if (user?.accountType !== "marketer") return "/";
  const first = CONTENT_SECTIONS.find((s) =>
    (user.contentAccess ?? []).includes(s.key)
  );
  return first ? first.path : "/no-access";
};
